/**
 * Site Header stores `blog`; the footer historically used `journal`.
 * Treat either key as omitted when the other is in `nav.omit`.
 */
export function isNavOmitted(
  pageKey: string,
  omit: Iterable<string> | Set<string>,
): boolean {
  const omitSet = omit instanceof Set ? omit : new Set(omit);
  if (omitSet.has(pageKey)) return true;
  if (pageKey === "journal" && omitSet.has("blog")) return true;
  if (pageKey === "blog" && omitSet.has("journal")) return true;
  return false;
}
